import { render } from "./HullRepair.vue?vue&type=template&id=22e6bc39"
import script from "./HullRepair.vue?vue&type=script&lang=js"
export * from "./HullRepair.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__